export default __webpack_public_path__ + "static/media/a016-8.45005cf6.png";